/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.EmployeeTemplatePromotions {
  angular.module("meevo.plugins.employeeTemplatePromotions", []);
}